import { makeStyles } from '@material-ui/core/styles'

export const co2LevelsOrgStyle = makeStyles((theme) => ({
  root: {
    width: '99%',
    marginTop: '2.5rem',
    display: 'flex',
    height: '330px'
  },
  container: {
    flex: 1
  }
}))
